import { render, staticRenderFns } from "./NameAvatar.vue?vue&type=template&id=81862540&scoped=true&"
import script from "./NameAvatar.vue?vue&type=script&lang=js&"
export * from "./NameAvatar.vue?vue&type=script&lang=js&"
import style0 from "./NameAvatar.vue?vue&type=style&index=0&id=81862540&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81862540",
  null
  
)

export default component.exports